import { render, staticRenderFns } from "./WorkSelectNote.vue?vue&type=template&id=5cd6787a&"
import script from "./WorkSelectNote.vue?vue&type=script&lang=js&"
export * from "./WorkSelectNote.vue?vue&type=script&lang=js&"
import style0 from "./WorkSelectNote.vue?vue&type=style&index=0&id=5cd6787a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports